<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-form-item label="平台渠道：" class="hide_input">
            <el-radio-group v-model="queryParams.channel">
              <el-radio>全部</el-radio>
              <el-radio :label="1">亚马逊</el-radio>
              <el-radio :label="2">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="店铺名称：" class="hide_input">
            <el-radio-group v-model="queryParams.shop_name">
              <el-radio>全部</el-radio>
              <el-radio :label="1">xowvo9a2@163.com 家居1_MY</el-radio>
              <el-radio :label="2">Scoinhouse_SG</el-radio>
              <el-radio :label="3">Scoinhouse_TH</el-radio>
              <el-radio :label="4">Scoinhouse_ID</el-radio>
              <el-radio :label="5">Scoinhouse_PH</el-radio>
              <el-radio :label="6">Famebaby_ID</el-radio>
              <el-radio :label="7">XX的自助订单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="订单编号：">
            <el-input
              size="small"
              style="width: 260px"
              v-model="queryParams.order"
              placeholder="多个订单编号用英文逗号隔开"
            ></el-input>
            <el-button size="small" style="margin-left: 10px" type="primary">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
      <el-table
        v-loading="loading"
        :data="tableData"
        border
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="品台产品" prop=""></el-table-column>
        <el-table-column label="订单状态【匹配类型】" prop=""></el-table-column>
        <el-table-column label="订制产品" prop=""></el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb';

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        pageSize: 30,
        pageNum: 1,
      },
      importFileVisible: false,
      fileForm: {},
      total: 0,
      loading: false,
      tableData: [
        {
          importId: 322111,
          ctime: '2021-04-10 23:22:21',
          shop: 'lnnhbt@163.com',
          order_num: 4,
          status: '导入成功',
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /* 获取列表数据 */
    loadData() {
      this.total = 1;
    },
    /* 下载数据 */
    handleDownload(row) {},
  },
};
</script>

<style lang="scss" scoped></style>
